<template>
  <div class="container-fuild ucenter">
    <el-row>
      <el-col :span="4">
        <div class="ucenter-sidebar cf">
          <slot name="menu"></slot>
        </div>
      </el-col>
      <el-col :span="20">
        <div class="ucenter-body cf">
          <header class="ucenter-title" v-if="!!$route.meta.title">
            <h2>{{$route.meta.title}}</h2>
            <!-- <el-breadcrumb separator="/">
              <el-breadcrumb-item v-for="(item, index) in $route.matched" :to="item">{{item.meta.title}}</el-breadcrumb-item>
            </el-breadcrumb> -->
          </header>
          <transition name="slide-fade" mode="out-in" appear>
            <router-view></router-view>
          </transition>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.ucenter {
  margin-top: 36px;
  margin-bottom: 100px;
  border-radius: 3px;
  background: #fff;
}

.ucenter-title {
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.ucenter-title > h2 {
  font-size: 16px;
  font-weight: normal;
  color: #97a8be;
  margin: 0;
}

.ucenter-body {
  border-left: 1px dashed #e9ecf1;
}

.ucenter-sidebar,
.ucenter-body {
  min-height: 680px;
}

.ucenter-body {
  padding: 20px;
}

/* 路由动画类 */
.slide-fade-enter-active {
  transition: all .15s ease;
}
.slide-fade-leave-active {
  transition: all .15s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-active {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// layout-ucenter.vue?24469827